// =========================================================================================================================
// Arabic: ربي يسر ولا تعسر ,و تمم بالخير
// English: O my Lord, make this task easy for me, and do not make it difficult for me and let my affairs end with goodness.
// Code Author: Muhammad Muashir uddin
// =========================================================================================================================

import { contain } from "three/src/extras/TextureUtils.js";
import { getAsset } from "../getAsset";

export function addDiv(container, id, className = null) {
  let div = document.createElement("div");
  if (id) {
    div.id = id;
  }
  if (className) {
    div.className = className;
  }
  if (container) {
    container.appendChild(div);
  }
  return div;
}
export function addMenuBtn(menu, id, icon, enable = true) {
  // let div = document.createElement("div");
  // div.id = id;
  // div.classList.add("menuBtn");
  let img = document.createElement("img");
  img.id = id;
  img.classList.add("menuIcon");
  // img.src = "/images/" + icon;
  img.src = getAsset(icon, "images");
  if (!enable) {
    img.style.filter = "grayscale(100%)";
  }
  img.setAttribute("enable", enable);
  // div.appendChild(img);
  menu.appendChild(img);
  return img;
  // menu.appendChild(div);
}
export function addInput(container, id, placeholder, className) {
  let input = document.createElement("input");
  input.id = id;
  input.placeholder = placeholder;
  input.autocomplete = "off";
  input.className = className;
  container.appendChild(input);
  return input;
}
export function addImage(container, id, src, className) {
  let img = document.createElement("img");
  img.id = id;
  img.src = getAsset(src, "images");
  // img.src = "/images/" + src;
  img.className = className;
  container.appendChild(img);
  return img;
}
export function addLabel(container, caption, className) {
  let div = document.createElement("div");
  div.className = className;
  div.style.userSelect = "none";
  div.innerText = caption;
  container.appendChild(div);
  return div;
}
export function addHorizLine(container) {
  let div = document.createElement("div");
  div.style.height = "1px";
  div.style.width = "100%";
  div.style.margin = "5px 0px";
  div.style.borderBottom = "1px solid #CCCCCC";
  container.appendChild(div);
  return div;
}
export function addColorPicker(container, id, className) {
  let cp = document.createElement("div");
  cp.id = id;
  cp.classList.add(className);
  container.appendChild(cp);
  let colorInput = document.createElement("input");
  colorInput.type = "color";
  colorInput.style.position = "absolute";
  colorInput.style.opacity = "0.01";
  colorInput.style.left = 0;
  colorInput.style.top = 0;
  cp.appendChild(colorInput);
  return cp;
}
export function addButton(container, id, caption, className) {
  let div = document.createElement("div");
  div.id = id;
  div.classList.add(className);
  div.innerText = caption;
  container.appendChild(div);
  return div;
}
export function addCheckbox(container, id, label, checked, className) {
  let div = document.createElement("div");
  div.id = id;
  div.style.display = "flex";
  div.classList.add(className);
  div.setAttribute("itemType", "chkbox");
  container.appendChild(div);

  let box = document.createElement("div");
  box.classList.add("chkboxBox");
  div.appendChild(box);

  let tick = document.createElement("img");
  tick.classList.add("chkboxTick");
  // tick.src = "/images/tick.svg";
  tick.src = getAsset("tick.svg", "images");
  tick.style.opacity = checked ? 1 : 0;
  box.appendChild(tick);

  let lbl = addLabel(div, label, "");
  lbl.classList.add("chkboxLabel");
  div.appendChild(lbl);

  return div;
}
